import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useLatest, useToggle } from 'react-use';
import { get } from 'lodash';
import { useResetGainsMutation } from 'apis/cm';
import { PERMISSION_ERROR_MESSAGE } from 'common/utils/constants';

function useResetGains(device, options) {
  const deviceRef = useLatest(device);
  const permitted = useSelector((state) =>
    state.data.rolePermissions.permissions.includes('cm_delete_sector_prov_data')
  );

  const [open, toggleOpen] = useToggle(false);
  const mutation = useResetGainsMutation(options);
  const sector = device?.type ? device.type.slice(2) : 0;
  const operationalState = get(device, 'rfPath.service-info.operational-state', 'disabled');

  const locked = operationalState === 'disabled';
  const connected = device?.connectionState === 'Connected';

  const { mutate, isLoading } = mutation;
  const resetSectorGains = useCallback(() => {
    const { donorId } = deviceRef.current;
    toggleOpen(false);
    mutate({
      deviceId: donorId,
      sector: parseInt(sector, 10)
    });
  }, [deviceRef, toggleOpen, mutate, sector]);
  const errors = validate({ connected, locked, permitted });

  return {
    mutation,
    trigger: {
      onClick: toggleOpen,
      disabled: errors.length > 0 || isLoading
    },
    tooltip: {
      title: errors.length > 0 ? errors[0].message : undefined
    },
    dialog: {
      open,
      locked,
      sector,
      onCancel: toggleOpen,
      onConfirm: resetSectorGains
    }
  };
}

export default useResetGains;

function validate({ connected, locked, permitted }) {
  const errors = [];

  if (!connected) {
    errors.push({
      type: 'device',
      message: 'Device is offline'
    });
  }

  if (!locked) {
    errors.push({
      type: 'device',
      message: 'Sector must be out of service in order to reset gains'
    });
  }

  if (!permitted) {
    errors.push({
      type: 'user',
      message: PERMISSION_ERROR_MESSAGE
    });
  }

  return errors;
}
